import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Notificacao } from '../../../interfaces/notificacao';
import { montarNotificacao, NotificacaoMontada, notificacaoVisual, NotificacaoVisual } from '../../../utils/notificacao-render';

/**
 * Card de leitura da notificação — o mesmo no diálogo do sino e na página
 * /others/notificacao/:id. Equivale à janela de leitura do desktop
 * (NotificacaoViewer): faixa na cor do tipo, capa, corpo com links tratados e
 * botão de ação em destaque.
 *
 * ViewEncapsulation.None porque o corpo entra por innerHTML e precisa dos
 * estilos (links-botão, tabelas, imagens); as classes levam o prefixo nt-.
 */
@Component({
  selector: 'app-notificacao-card',
  templateUrl: './notificacao-card.component.html',
  styleUrls: ['./notificacao-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificacaoCardComponent implements OnChanges {

  @Input() notificacao: Notificacao;
  /** Escala do texto do corpo (1 = normal). */
  @Input() zoom = 1;

  /** Clique no botão de ação ou na capa — quem usa decide se fecha o diálogo. */
  @Output() acao = new EventEmitter<string>();

  visual: NotificacaoVisual;
  montada: NotificacaoMontada;
  corpo: SafeHtml | null = null;
  diasRestantes: number | null = null;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(): void {
    const n = this.notificacao;
    this.visual = notificacaoVisual(n?.tipoNotificacao);
    this.montada = montarNotificacao(n ?? {} as any);
    // montarNotificacao já passou o corpo pelo DOMPurify
    this.corpo = this.montada.corpoHtml ? this.sanitizer.bypassSecurityTrustHtml(this.montada.corpoHtml) : null;
    this.diasRestantes = this.calcularDiasRestantes(n?.validade);
  }

  get titulo(): string {
    return this.notificacao?.titulo || 'Notificação';
  }

  clicou(url: string) {
    this.acao.emit(url);
  }

  /** Contagem regressiva só na reta final — é o que dá urgência a uma oferta. */
  private calcularDiasRestantes(validade?: Date | string): number | null {
    if (!validade) {
      return null;
    }
    const fim = new Date(validade);
    if (isNaN(fim.getTime())) {
      return null;
    }
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    fim.setHours(0, 0, 0, 0);
    const dias = Math.round((fim.getTime() - hoje.getTime()) / 86400000);
    return dias >= 0 && dias <= 7 ? dias : null;
  }
}
